// Azure migration: update API endpoint and key for Azure resources
//export const domain = 'https://api.test.tis.coke.com';
export const domain = 'https://apiazr.test.tis.coke.com';
export const stage = 'test';
export const featureFlags = {
  authorization: true
};
